import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subject, finalize, of, throwError } from 'rxjs';
import {
    debounceTime,
    distinctUntilChanged,
    switchMap,
    catchError,
    tap,
    map,
    takeUntil,
} from 'rxjs/operators';
import { helper } from 'src/environments/helper';
import { NotificationService } from '../../../services/notification.service';
import { DashboardService } from '../dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common.service';
import { Generic, GenericCompartimentSearch } from 'src/app/interfaces/generic.interface';
import { UserOrganigramaSearchPayload } from 'src/app/interfaces/common.interface';
import { notDefaultValidator } from 'src/app/validators/not-default';
import { ToStiintaRecordsRow, FileUpload, GeneralData, DocumentData, EntityDocument } from '../document.interface';
import { formatDate } from '@angular/common';
import { SearchEntitate } from '../../entitati/entitati.interface';
import { AppFilesService } from 'src/app/services/app-files.service';
import Swal from 'sweetalert2';
import { ToastService } from 'src/app/services/toast.service';

interface Sursa {
    id: number,
    name: string,
}

@Component({
    selector: 'app-document-iesire',
    templateUrl: './document-iesire.component.html',
    styleUrls: ['./document-iesire.component.scss'],
})
export class DocumentIesireComponent implements OnInit {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;

    today: Date = new Date();
    isLoading = false;
    uploading = false;

    showRegistreFields = true;
    showProceduraField = true;
    showFormFiles = false;
    showStiintaInfoForm = false;
    showStiintaFullForm = false;

    registruOficialGeneralValue: number | null = null;

    docData: DocumentData | null = null;

    toStiintaRecords: ToStiintaRecordsRow[] = [];

    defaultTaraId: number | null = null;
    defaultTaraLabel: string = '';
    defaultJudetId: number | null = null;
    defaultJudetLabel: string = '';
    defaultLocalitateId: number | null = null;
    defaultLocalitateLabel: string = '';

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    newNumberOptions: { name: string; id: number }[] = [
        {
            name: '--Alegeți--',
            id: -1,
        },
        {
            name: 'Emitere cu număr existent din registru selectat: ',
            id: 1,
        },
        {
            name: 'Număr nou/la rând',
            id: 2,
        },
    ];

    registreOptions: { name: string; id: number }[] = [
        {
            name: 'Număr din oficiu/nou',
            id: 1,
        },
        {
            name: 'Număr anterior, ieșire zi curentă',
            id: 2,
        },
    ];

    proceduriDocumentOptions: { name: string; id: number }[] = [
        {
            name: '--Alegeți--',
            id: -1,
        },
        {
            name: 'Preluare număr pentru pregătire documentație',
            id: 1,
        },
        {
            name: 'Transmitere Registratură pentru ieșire Instituție',
            id: 2,
        },
    ];

    form: FormGroup = new FormGroup({
        id_categorie: new FormControl(2, []), // Hard coded for doc iesire

        new_number: new FormControl(-1, []),
        id_serie: new FormControl(-1, []),
        registratura_number_type: new FormControl(1, [Validators.required, notDefaultValidator('-1')]),
        registratura_number: new FormControl('', []),
        exit_document_format: new FormControl(-1, [Validators.required, notDefaultValidator('-1')]),
        source: new FormControl(-1, []),
        // sourceArr: this.fb.array([]), // Added in submitForm!
        id_tip_document: new FormControl(null, [Validators.required]),
        name_tip_document: new FormControl('', [Validators.required]),

        parent_no: new FormControl('', []),
        parent_year: new FormControl(2025, []),
        observatii: new FormControl('', [Validators.required]),
        keywords: new FormControl('', [Validators.required]),
        no_pages: new FormControl('', [Validators.required]),

        // instiintare: this.fb.array([]), // Added in submitForm!

        // needed ?
        // type_document: new FormControl(1, []),
        // id_print: new FormControl(0, []),
        // extern_numar: new FormControl('', []),
        // extern_date: new FormControl('', []),
        // extern_date_input: new FormControl('', []),
        // numar_rezervat: new FormControl('', []),
        // data_rezervata: new FormControl('', []),
        // document_compartiment: new FormControl(-1, []),
        // mentiuni: new FormControl('', []),
        // awb_required: new FormControl(0, []),
        // text_print: new FormControl('', []),
        // id_petent_pv: new FormControl('', []),
        // rezervare_date: new FormControl('', []),
    });

    formSecundar: FormGroup = new FormGroup({
        directie_id: new FormControl(null, []),
        directie_name: new FormControl('', []),
        compartiment_id: new FormControl(null, []),
        compartiment_name: new FormControl('', []),
        user_id: new FormControl(-1, []),
        user_name: new FormControl('', []),
    })

    formEmitent: FormGroup = new FormGroup({
        type: new FormControl(1, []), // Hard coded emitent
        id: new FormControl(null, []), // needed ?
        id_address_type: new FormControl(1, []), // Cetatean default!
        denumire: new FormControl('', []),
        pers_contact: new FormControl('', []),
        denumire_select: new FormControl('', []),
        directie_id: new FormControl(null, []),
        directie_name: new FormControl('', []),
        compartiment_id: new FormControl(null, []),
        compartiment_name: new FormControl('', []),
        user_id: new FormControl(-1, []),
        user_name: new FormControl('', []),
        cnp_cui: new FormControl('', [Validators.required]), // Cetatean default!
        email: new FormControl('', []),
        telefon: new FormControl('', []),
        id_tara: new FormControl(this.defaultTaraId, []),
        name_tara: new FormControl(this.defaultTaraLabel, []),
        id_judet: new FormControl(this.defaultJudetId, []),
        name_judet: new FormControl(this.defaultJudetLabel, []),
        id_localitate: new FormControl(this.defaultLocalitateId, []),
        name_localitate: new FormControl(this.defaultLocalitateLabel, []),
        sector: new FormControl('-1', []),
        id_strada: new FormControl(null, []),
        name_strada: new FormControl('', []),
        numar: new FormControl('', []),
        bloc: new FormControl('', []),
        scara: new FormControl('', []),
        apartament: new FormControl('', []),
        cod_postal: new FormControl('', []),
        numar_deces: new FormControl('', []),
        data_deces_input: new FormControl('', []),
        person_status: new FormControl(false, []),
        observatii: new FormControl('', []),
    });

    formFiles: FormGroup = new FormGroup({
        files: this.fb.array([], [Validators.required]),
    })

    formStiinta: FormGroup = new FormGroup({
        type: new FormControl(2, []), // Hard coded stiinta
        key: new FormControl(null, []), // Added in submitForm!
        id: new FormControl(null, []),
        id_address_type: new FormControl(1, []), // Cetatean default!
        denumire: new FormControl('', []),
        pers_contact: new FormControl('', []),
        denumire_select: new FormControl('', []),
        directie_id: new FormControl(null, []),
        directie_name: new FormControl('', []),
        compartiment_id: new FormControl(null, []),
        compartiment_name: new FormControl('', []),
        user_id: new FormControl(-1, []),
        user_name: new FormControl('', []),
        cnp_cui: new FormControl('', []),
        email: new FormControl('', []),
        telefon: new FormControl('', []),
        id_tara: new FormControl(this.defaultTaraId, []),
        name_tara: new FormControl(this.defaultTaraLabel, []),
        id_judet: new FormControl(this.defaultJudetId, []),
        name_judet: new FormControl(this.defaultJudetLabel, []),
        id_localitate: new FormControl(this.defaultLocalitateId, []),
        name_localitate: new FormControl(this.defaultLocalitateLabel, []),
        sector: new FormControl('-1', []),
        id_strada: new FormControl(null, []),
        name_strada: new FormControl('', []),
        numar: new FormControl('', []),
        bloc: new FormControl('', []),
        scara: new FormControl('', []),
        apartament: new FormControl('', []),
        cod_postal: new FormControl('', []),
        observatii: new FormControl('', []),
    });

    private destroy$ = new Subject<void>();

    registreActiveSwitch: Generic[] = [];

    surse: Generic[] = [];
    sourceArr: Sursa[] = [];

    tipDocumente: Generic[] = [];
    tipDocumenteControl = new FormControl('', [Validators.required]);
    isTipDocumenteLoading = false;
    showTipDocumenteMessage = true;
    tipDocumenteLoadComplete = false;

    directiiSecundar: Generic[] = [];
    filteredDirectiiSecundar: Generic[] = [];
    directiiSecundarControl = new FormControl();

    compartimenteSecundar: GenericCompartimentSearch[] = [];
    compartimenteSecundarControl = new FormControl();
    isCompartimenteSecundarLoading = false;
    showCompartimenteSecundarMessage = true;
    compartimenteSecundarLoadComplete = false;

    operatoriSecundar: Generic[] = [];
    filteredOperatoriSecundar: Generic[] = [];
    operatoriSecundarControl = new FormControl();

    entitatiEmitent: SearchEntitate[] = [];
    entitatiEmitentControl = new FormControl();
    isEntitatiEmitentLoading = false;
    showEntitatiEmitentMessage = true;
    entitatiEmitentLoadComplete = false;

    entitatiEmitentByCNP: SearchEntitate[] = [];
    entitatiEmitentByCNPControl: FormControl<any> = new FormControl('', [Validators.required]);
    isEntitatiEmitentByCNPLoading = false;
    showEntitatiEmitentByCNPMessage = true;
    entitatiEmitentByCNPLoadComplete = false;

    directiiEmitent: Generic[] = [];
    filteredDirectiiEmitent: Generic[] = [];
    directiiEmitentControl = new FormControl();

    compartimenteEmitent: GenericCompartimentSearch[] = [];
    compartimenteEmitentControl = new FormControl();
    isCompartimenteEmitentLoading = false;
    showCompartimenteEmitentMessage = true;
    compartimenteEmitentLoadComplete = false;

    operatoriEmitent: Generic[] = [];
    filteredOperatoriEmitent: Generic[] = [];
    operatoriEmitentControl = new FormControl();

    tariEmitent: Generic[] = [];
    filteredTariEmitent: Generic[] = [];
    tariEmitentControl = new FormControl();

    judeteEmitent: Generic[] = [];
    filteredJudeteEmitent: Generic[] = [];
    judeteEmitentControl = new FormControl();

    localitatiEmitent: Generic[] = [];
    localitatiEmitentControl = new FormControl();
    isLocalitatiEmitentLoading = false;
    showLocalitatiEmitentMessage = true;
    localitatiEmitentLoadComplete = false;

    straziEmitent: Generic[] = [];
    straziEmitentControl = new FormControl();
    isStraziEmitentLoading = false;
    showStraziEmitentMessage = true;
    straziEmitentLoadComplete = false;
    lastStraziEmitentValue = '';

    entitatiStiinta: SearchEntitate[] = [];
    entitatiStiintaControl = new FormControl();
    isEntitatiStiintaLoading = false;
    showEntitatiStiintaMessage = true;
    entitatiStiintaLoadComplete = false;

    entitatiStiintaByCNP: SearchEntitate[] = [];
    entitatiStiintaByCNPControl = new FormControl();
    isEntitatiStiintaByCNPLoading = false;
    showEntitatiStiintaByCNPMessage = true;
    entitatiStiintaByCNPLoadComplete = false;

    directiiStiinta: Generic[] = [];
    filteredDirectiiStiinta: Generic[] = [];
    directiiStiintaControl = new FormControl();

    compartimenteStiinta: GenericCompartimentSearch[] = [];
    compartimenteStiintaControl = new FormControl();
    isCompartimenteStiintaLoading = false;
    showCompartimenteStiintaMessage = true;
    compartimenteStiintaLoadComplete = false;

    operatoriStiinta: Generic[] = [];
    filteredOperatoriStiinta: Generic[] = [];
    operatoriStiintaControl = new FormControl();

    tariStiinta: Generic[] = [];
    filteredTariStiinta: Generic[] = [];
    tariStiintaControl = new FormControl();

    judeteStiinta: Generic[] = [];
    filteredJudeteStiinta: Generic[] = [];
    judeteStiintaControl = new FormControl();

    localitatiStiinta: Generic[] = [];
    localitatiStiintaControl = new FormControl();
    isLocalitatiStiintaLoading = false;
    showLocalitatiStiintaMessage = true;
    localitatiStiintaLoadComplete = false;
    lastStraziStiintaValue = '';

    straziStiinta: Generic[] = [];
    straziStiintaControl = new FormControl();
    isStraziStiintaLoading = false;
    showStraziStiintaMessage = true;
    straziStiintaLoadComplete = false;

    selectedSerieDocument: string | null = null;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            generalData: GeneralData[],
            docData?: DocumentData,
            docType?: number | 1,
            serieId?: number | -1,
            reg_number?: string,
            idDocumentActivity?: number
        },
        private dialogRef: MatDialogRef<DocumentIesireComponent>,
        private fb: FormBuilder,
        private toastr: ToastrService,
        private dashboardService: DashboardService,
        private commonService: CommonService,
        private notificationService: NotificationService,
        private appFilesService: AppFilesService,
        private toastService: ToastService,
    ) {
        this.data.generalData.forEach(item => {
            if (item.name === 'default_adresa_tara' && Number(item.value) > 0 && item.label) {
                this.defaultTaraId = Number(item.value);
                this.defaultTaraLabel = item.label || '';
            } else if (item.name === 'default_adresa_judet' && Number(item.value) > 0 && item.label) {
                this.defaultJudetId = Number(item.value);
                this.defaultJudetLabel = item.label || '';
            } else if (item.name === 'default_adresa_localitate' && Number(item.value) > 0 && item.label) {
                this.defaultLocalitateId = Number(item.value);
                this.defaultLocalitateLabel = item.label || '';
            }

            // if (item.name === 'registru_oficial') {
            //     this.registruOficialGeneralValue = Number(item.value) || null;
            // }
        })

        // If docData exists, it means the component is run from view doc!
        this.docData = data.docData ? data.docData : null;
    }

    ngOnInit() {

        this.isLoading = true

        this.loadActiveSwitch();
        this.loadSurseActive();
        this.loadDirectiiActive();

        this.loadTariActive();
        this.loadDefaultLocatieStiinta();

        if (this.data.serieId) {
            this.form.controls['id_serie'].patchValue(this.data.serieId);
            // this.onRegisteActiveSelected(this.data.serieId);
        }

        if (this.docData) {
            this.newNumberOptions[1].name = `Emitere cu număr existent din registru selectat: ${this.data.reg_number}`;
            this.form.controls['new_number'].setValidators([Validators.required, notDefaultValidator('-1')]);
            this.form.controls['new_number'].patchValue(1);
            this.form.controls['id_serie'].patchValue(this.data.serieId);

            this.showRegistreFields = false;

            // Update emitent with docData
            if (this.docData.entity) this.updateFormEmitent(this.docData.entity);
        } else {
            this.form.controls['id_serie'].setValidators([Validators.required, notDefaultValidator('-1')]);

            // Load default locatie emitent, if we don't update form emitent
            this.loadDefaultLocatieEmitent()
        }

        this.tipDocumenteControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(value => {
            if (typeof value === 'string') {
                this.fetchTipDocumente(value);
                this.showTipDocumenteMessage = true;
                this.tipDocumenteLoadComplete = false;
            }
        });

        this.compartimenteSecundarControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(compartiment => {
            if (typeof compartiment === 'string') {
                this.fetchCompartimenteSecundar(compartiment);
                this.showCompartimenteSecundarMessage = true;
                this.compartimenteSecundarLoadComplete = false;
            }
        });

        this.entitatiEmitentControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(value => {
            if (typeof value === 'string') {
                this.fetchEntitatiEmitent(value);
                this.showEntitatiEmitentMessage = true;
                this.entitatiEmitentLoadComplete = false;
            }
        });

        this.entitatiEmitentByCNPControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(value => {
            if (typeof value === 'string') {
                this.fetchEntitatiEmitentByCNP(value);
                this.showEntitatiEmitentByCNPMessage = true;
                this.entitatiEmitentByCNPLoadComplete = false;
            }
        });

        this.compartimenteEmitentControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(compartiment => {
            if (typeof compartiment === 'string') {
                this.fetchCompartimenteEmitent(compartiment);
                this.showCompartimenteEmitentMessage = true;
                this.compartimenteEmitentLoadComplete = false;
            }
        });

        this.localitatiEmitentControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(localitate => {
            if (typeof localitate === 'string') {
                this.fetchLocalitatiEmitent(localitate);
                this.showLocalitatiEmitentMessage = true;
                this.localitatiEmitentLoadComplete = false;
            }
        });

        this.straziEmitentControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(strada => {
            if (typeof strada === 'string') {
                this.fetchStraziEmitent(strada);
                this.showStraziEmitentMessage = true;
                this.straziEmitentLoadComplete = false;
            }
        });

        this.entitatiStiintaControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(value => {
            if (typeof value === 'string') {
                this.fetchEntitatiStiinta(value);
                this.showEntitatiStiintaMessage = true;
                this.entitatiStiintaLoadComplete = false;
            }
        });

        this.entitatiStiintaByCNPControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(value => {
            if (typeof value === 'string') {
                this.fetchEntitatiStiintaByCNP(value);
                this.showEntitatiStiintaByCNPMessage = true;
                this.entitatiStiintaByCNPLoadComplete = false;
            }
        });

        this.compartimenteStiintaControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(compartiment => {
            if (typeof compartiment === 'string') {
                this.fetchCompartimenteStiinta(compartiment);
                this.showCompartimenteStiintaMessage = true;
                this.compartimenteStiintaLoadComplete = false;
            }
        });

        this.localitatiStiintaControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(localitate => {
            if (typeof localitate === 'string') {
                this.fetchLocalitatiStiinta(localitate);
                this.showLocalitatiStiintaMessage = true;
                this.localitatiStiintaLoadComplete = false;
            }
        });

        this.straziStiintaControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(strada => {
            if (typeof strada === 'string') {
                this.fetchStraziStiinta(strada);
                this.showStraziStiintaMessage = true;
                this.straziStiintaLoadComplete = false;
            }
        });

        this.renderFieldsSearch();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }


    // START -- Methods for getting data -- START
    renderFieldsSearch() {
        this.directiiSecundarControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.directiiSecundar);
                }
                if (inputValue.length < 1) {
                    this.filteredDirectiiSecundar = this.directiiSecundar;
                    return of(this.directiiSecundar);
                }
                return this.filterDirectiiSecundar(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredDirectiiSecundar = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.operatoriSecundarControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.operatoriSecundar);
                }
                if (inputValue.length < 1) {
                    this.filteredOperatoriSecundar = this.operatoriSecundar;
                    return of(this.operatoriSecundar);
                }
                return this.filterOperatoriSecundar(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredOperatoriSecundar = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.directiiEmitentControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.directiiEmitent);
                }
                if (inputValue.length < 1) {
                    this.filteredDirectiiEmitent = this.directiiEmitent;
                    return of(this.directiiEmitent);
                }
                return this.filterDirectiiEmitent(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredDirectiiEmitent = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.operatoriEmitentControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.operatoriEmitent);
                }
                if (inputValue.length < 1) {
                    this.filteredOperatoriEmitent = this.operatoriEmitent;
                    return of(this.operatoriEmitent);
                }
                return this.filterOperatoriEmitent(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredOperatoriEmitent = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.tariEmitentControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.tariEmitent);
                }
                if (inputValue.length < 1) {
                    this.filteredTariEmitent = this.tariEmitent;
                    return of(this.tariEmitent);
                }
                return this.filterTariEmitent(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredTariEmitent = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.judeteEmitentControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.judeteEmitent);
                }
                if (inputValue.length < 1) {
                    this.filteredJudeteEmitent = this.judeteEmitent;
                    return of(this.judeteEmitent);
                }
                return this.filterJudeteEmitent(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredJudeteEmitent = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.directiiStiintaControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.directiiStiinta);
                }
                if (inputValue.length < 1) {
                    this.filteredDirectiiStiinta = this.directiiStiinta;
                    return of(this.directiiStiinta);
                }
                return this.filterDirectiiStiinta(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredDirectiiStiinta = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.operatoriStiintaControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.operatoriStiinta);
                }
                if (inputValue.length < 1) {
                    this.filteredOperatoriStiinta = this.operatoriStiinta;
                    return of(this.operatoriStiinta);
                }
                return this.filterOperatoriStiinta(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredOperatoriStiinta = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.tariStiintaControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.tariStiinta);
                }
                if (inputValue.length < 1) {
                    this.filteredTariStiinta = this.tariStiinta;
                    return of(this.tariStiinta);
                }
                return this.filterTariStiinta(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredTariStiinta = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.judeteStiintaControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.judeteStiinta);
                }
                if (inputValue.length < 1) {
                    this.filteredJudeteStiinta = this.judeteStiinta;
                    return of(this.judeteStiinta);
                }
                return this.filterJudeteStiinta(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredJudeteStiinta = data;
            }),
            catchError(() => of([]))
        ).subscribe();
    }

    loadActiveSwitch() {
        this.isLoading = true;
        this.commonService
            .getActiveSwitch()
            .pipe(
                map((resp: Generic[]) => [this.defaultParameter, ...resp]),
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.isLoading = false;
                    this.registreActiveSwitch = results;

                    // this formula is needed for only where we have ID Document or ID Document Activity BINDED
                    if (this.data.serieId && this.data.serieId !== -1) {
                        const foundSerie = this.registreActiveSwitch.find((obj: Generic) =>
                            Number(obj.id) === this.data.serieId
                        );
                        this.selectedSerieDocument = foundSerie?.name || null;
                        console.log('Selected serie from data:', this.selectedSerieDocument);
                    } else {
                        this.selectedSerieDocument = this.docData?.serie?.name ? this.docData.serie.name : null;
                        console.log('Selected serie from data:', this.selectedSerieDocument);
                    }
                },
                error: (error) => {
                    console.error('Error loading directii', error);
                },
            });
    }

    loadSurseActive() {
        this.isLoading = true;
        this.commonService
            .getSurseActive()
            .pipe(
                // takeUntil(this.destroy$),
                map((resp: Generic[]) => [this.defaultParameter, ...resp]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.surse = results;
                },
                error: (error) => {
                    console.error('Error loading surse', error);
                    this.isLoading = false;
                },
            });
    }

    fetchTipDocumente(search: string) {
        if (search && search.length >= 2) {
            this.isTipDocumenteLoading = true;
            this.commonService.searchTipDocumente(search).subscribe({
                next: (response: Generic[]) => {
                    this.tipDocumente = response;
                    this.isTipDocumenteLoading = false;
                    this.tipDocumenteLoadComplete = true;
                    this.showTipDocumenteMessage = this.tipDocumente.length === 0;
                },
                error: (err: any) => {
                    this.isTipDocumenteLoading = false;
                    this.showTipDocumenteMessage = true;
                    this.tipDocumenteLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.tipDocumente = [];
            this.showTipDocumenteMessage = true;
            this.tipDocumenteLoadComplete = false;
        }
    }

    onTipDocumenteSelected(selectedDocument: Generic) {
        if (selectedDocument) {
            this.form.controls['id_tip_document'].patchValue(selectedDocument.id);
            this.form.controls['name_tip_document'].patchValue(selectedDocument.name);
        }
    }

    displayTipDocumente(selectedDocument: Generic): string {
        return selectedDocument && selectedDocument.name ? selectedDocument.name : '';
    }

    onTipDocumenteBlur() {
        const currentValue = this.tipDocumenteControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.tipDocumenteControl.patchValue('');
            this.form.controls['id_tip_document'].patchValue('');
            this.form.controls['name_tip_document'].patchValue('');
        }
    }

    fetchEntitatiEmitent(entitate: string) {
        if (entitate && entitate.length >= 2) {
            this.isEntitatiEmitentLoading = true;
            this.commonService.searchEntitati(entitate).subscribe({
                next: (response: SearchEntitate[]) => {
                    this.entitatiEmitent = response;
                    this.isEntitatiEmitentLoading = false;
                    this.entitatiEmitentLoadComplete = true;
                    this.showEntitatiEmitentMessage = this.entitatiEmitent.length === 0;
                },
                error: (err: any) => {
                    this.isEntitatiEmitentLoading = false;
                    this.showEntitatiEmitentMessage = true;
                    this.entitatiEmitentLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.entitatiEmitent = [];
            this.showEntitatiEmitentMessage = true;
            this.entitatiEmitentLoadComplete = false;
        }
    }

    onEntitateEmitentSelected(selectedEntitate: SearchEntitate) {
        if (selectedEntitate) {
            this.updateFormEmitent(selectedEntitate, 'name');
        }
    }

    displayEntitateEmitent(entitate: SearchEntitate): string {
        return entitate && entitate.denumire ? entitate.denumire : '';
    }

    onEntitateEmitentChange() {
        const currentValue = this.entitatiEmitentControl.value;

        if (typeof currentValue === 'string') {
            this.formEmitent.controls['id'].patchValue(null);
            this.formEmitent.controls['denumire_select'].patchValue(currentValue);
        }
    }

    fetchEntitatiEmitentByCNP(cnp: string) {
        const currentEntitateType = this.formEmitent.get('id_address_type')?.value;

        if (cnp && cnp.length >= 2) {
            this.isEntitatiEmitentByCNPLoading = true;
            this.commonService.searchEntitatiByCNP(cnp, currentEntitateType).subscribe({
                next: (response: SearchEntitate[]) => {
                    this.entitatiEmitentByCNP = response;
                    this.isEntitatiEmitentByCNPLoading = false;
                    this.entitatiEmitentByCNPLoadComplete = true;
                    this.showEntitatiEmitentByCNPMessage = this.entitatiEmitentByCNP.length === 0;
                },
                error: (err: any) => {
                    this.isEntitatiEmitentByCNPLoading = false;
                    this.showEntitatiEmitentByCNPMessage = true;
                    this.entitatiEmitentByCNPLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.entitatiEmitentByCNP = [];
            this.showEntitatiEmitentByCNPMessage = true;
            this.entitatiEmitentByCNPLoadComplete = false;
        }
    }

    onEntitateEmitentByCNPSelected(selectedEntitate: SearchEntitate) {
        if (selectedEntitate) {
            this.updateFormEmitent(selectedEntitate, 'cnp');
        }
    }

    displayEntitateEmitentByCNP(entitate: SearchEntitate): string {
        return entitate && entitate.cnp_cui ? entitate.cnp_cui : '';
    }

    onEntitateEmitentByCNPChange() {
        const currentValue = this.entitatiEmitentByCNPControl.value;

        if (typeof currentValue === 'string') {
            this.formEmitent.controls['id'].patchValue(null);
            this.formEmitent.controls['cnp_cui'].patchValue(currentValue);
        }
    }

    updateFormEmitent(selectedEntitate: SearchEntitate | EntityDocument, updateType?: 'name' | 'cnp') {
        const selectedEntitateType = selectedEntitate.id_address_type;
        const currentEntitateType = this.formEmitent.get('id_address_type')?.value;
        const searchedEntitati = this.entitatiEmitent;
        const searchedEntitatiByCNP = this.entitatiEmitentByCNP;

        if (selectedEntitateType !== currentEntitateType) {
            this.formEmitent.get('id_address_type')?.patchValue(selectedEntitateType);
            this.resetFormEmitent(selectedEntitateType);
        }

        if (updateType === 'name') {
            this.entitatiEmitent = searchedEntitati;
            this.entitatiEmitentByCNP = []
        }
        if (updateType === 'cnp') {
            this.entitatiEmitentByCNP = searchedEntitatiByCNP;
            this.entitatiEmitent = [];
        }

        if (selectedEntitateType === 1 || selectedEntitateType === 2 || selectedEntitateType === 3) {
            this.entitatiEmitentControl.setValue(selectedEntitate);
            this.formEmitent.get('id')?.patchValue(selectedEntitate.id);
            this.formEmitent.get('denumire_select')?.patchValue(selectedEntitate.denumire);
            this.formEmitent.get('denumire')?.patchValue(selectedEntitate.denumire);

            if (selectedEntitateType === 2 || selectedEntitateType === 3) {
                this.formEmitent.get('pers_contact')?.patchValue(selectedEntitate.pers_contact);
            }
            if (selectedEntitateType === 1 || selectedEntitateType === 2) {
                this.entitatiEmitentByCNPControl.setValue(selectedEntitate);
                this.formEmitent.get('cnp_cui')?.patchValue(selectedEntitate.cnp_cui);
                this.formEmitent.get('email')?.patchValue(selectedEntitate.email);
                this.formEmitent.get('telefon')?.patchValue(selectedEntitate.telefon);
            }
            if (selectedEntitate.id_tara && selectedEntitate.name_tara) {
                this.tariEmitentControl.setValue({
                    id: selectedEntitate.id_tara,
                    name: selectedEntitate.name_tara
                })
                this.formEmitent.get('id_tara')?.patchValue(selectedEntitate.id_tara);
                this.formEmitent.get('name_tara')?.patchValue(selectedEntitate.name_tara);
                this.loadJudeteEmitent(selectedEntitate.id_tara);
            }
            if (selectedEntitate.id_judet && selectedEntitate.name_judet) {
                this.judeteEmitentControl.setValue({
                    id: selectedEntitate.id_judet,
                    name: selectedEntitate.name_judet
                })
                this.formEmitent.get('id_judet')?.patchValue(selectedEntitate.id_judet);
                this.formEmitent.get('name_judet')?.patchValue(selectedEntitate.name_judet);
            }
            if (selectedEntitate.id_localitate && selectedEntitate.name_localitate) {
                this.fetchLocalitatiEmitent(selectedEntitate.name_localitate);
                this.localitatiEmitentControl.setValue({
                    id: selectedEntitate.id_localitate,
                    name: selectedEntitate.name_localitate
                })
                this.formEmitent.get('id_localitate')?.patchValue(selectedEntitate.id_localitate);
                this.formEmitent.get('name_localitate')?.patchValue(selectedEntitate.name_localitate);
            }
            if (selectedEntitate.id_strada && selectedEntitate.name_strada) {
                this.fetchStraziEmitent(selectedEntitate.name_strada);
                this.straziEmitentControl.setValue({
                    id: selectedEntitate.id_strada,
                    name: selectedEntitate.name_strada
                })
                this.formEmitent.get('id_strada')?.patchValue(selectedEntitate.id_strada);
                this.formEmitent.get('name_strada')?.patchValue(selectedEntitate.name_strada);
            }

            this.formEmitent.get('sector')?.patchValue(selectedEntitate.sector);
            this.formEmitent.get('numar')?.patchValue(selectedEntitate.numar);
            this.formEmitent.get('bloc')?.patchValue(selectedEntitate.bloc);
            this.formEmitent.get('scara')?.patchValue(selectedEntitate.scara);
            this.formEmitent.get('apartament')?.patchValue(selectedEntitate.apartament);
            this.formEmitent.get('cod_postal')?.patchValue(selectedEntitate.cod_postal);
            this.formEmitent.get('numar_deces')?.patchValue(selectedEntitate.numar_deces);
            this.formEmitent.get('data_deces_input')?.patchValue(selectedEntitate.data_deces);
        }
    }

    fetchEntitatiStiinta(entitate: string) {
        if (entitate && entitate.length >= 2) {
            this.isEntitatiStiintaLoading = true;
            this.commonService.searchEntitati(entitate).subscribe({
                next: (response: SearchEntitate[]) => {
                    this.entitatiStiinta = response;
                    this.isEntitatiStiintaLoading = false;
                    this.entitatiStiintaLoadComplete = true;
                    this.showEntitatiStiintaMessage = this.entitatiStiinta.length === 0;
                },
                error: (err: any) => {
                    this.isEntitatiStiintaLoading = false;
                    this.showEntitatiStiintaMessage = true;
                    this.entitatiStiintaLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.entitatiStiinta = [];
            this.showEntitatiStiintaMessage = true;
            this.entitatiStiintaLoadComplete = false;
        }
    }

    onEntitateStiintaSelected(selectedEntitate: SearchEntitate) {
        if (selectedEntitate) {
            this.updateFormStiinta(selectedEntitate, 'name');
        }
    }

    displayEntitateStiinta(entitate: SearchEntitate): string {
        return entitate && entitate.denumire ? entitate.denumire : '';
    }

    onEntitateStiintaChange() {
        const currentValue = this.entitatiStiintaControl.value;

        if (typeof currentValue === 'string') {
            this.formStiinta.controls['id'].patchValue(null);
            this.formStiinta.controls['denumire_select'].patchValue(currentValue);
        }
    }

    fetchEntitatiStiintaByCNP(cnp: string) {
        const currentEntitateType = this.formStiinta.get('id_address_type')?.value;

        if (cnp && cnp.length >= 2) {
            this.isEntitatiStiintaByCNPLoading = true;
            this.commonService.searchEntitatiByCNP(cnp, currentEntitateType).subscribe({
                next: (response: SearchEntitate[]) => {
                    this.entitatiStiintaByCNP = response;
                    this.isEntitatiStiintaByCNPLoading = false;
                    this.entitatiStiintaByCNPLoadComplete = true;
                    this.showEntitatiStiintaByCNPMessage = this.entitatiStiintaByCNP.length === 0;
                },
                error: (err: any) => {
                    this.isEntitatiStiintaByCNPLoading = false;
                    this.showEntitatiStiintaByCNPMessage = true;
                    this.entitatiStiintaByCNPLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.entitatiStiintaByCNP = [];
            this.showEntitatiStiintaByCNPMessage = true;
            this.entitatiStiintaByCNPLoadComplete = false;
        }
    }

    onEntitateStiintaByCNPSelected(selectedEntitate: SearchEntitate) {
        if (selectedEntitate) {
            this.updateFormStiinta(selectedEntitate, 'cnp');
        }
    }

    displayEntitateStiintaByCNP(entitate: SearchEntitate): string {
        return entitate && entitate.cnp_cui ? entitate.cnp_cui : '';
    }

    onEntitateStiintaByCNPChange() {
        const currentValue = this.entitatiStiintaByCNPControl.value;

        if (typeof currentValue === 'string') {
            this.formStiinta.controls['id'].patchValue(null);
            this.formStiinta.controls['cnp_cui'].patchValue(currentValue);
        }
    }

    updateFormStiinta(selectedEntitate: SearchEntitate, updateType: 'name' | 'cnp') {
        const selectedEntitateType = selectedEntitate.id_address_type;
        const currentEntitateType = this.formStiinta.get('id_address_type')?.value;
        const searchedEntitati = this.entitatiStiinta;
        const searchedEntitatiByCNP = this.entitatiStiintaByCNP;

        if (selectedEntitateType !== currentEntitateType) {
            this.formStiinta.get('id_address_type')?.patchValue(selectedEntitateType);
            this.resetFormStiinta(selectedEntitateType);
        }

        if (updateType === 'name') {
            this.entitatiStiinta = searchedEntitati;
            this.entitatiStiintaByCNP = [];
        } else {
            this.entitatiStiintaByCNP = searchedEntitatiByCNP;
            this.entitatiStiinta = [];
        }

        if (selectedEntitateType === 1 || selectedEntitateType === 2 || selectedEntitateType === 3) {
            this.entitatiStiintaControl.setValue(selectedEntitate);
            this.formStiinta.get('id')?.patchValue(selectedEntitate.id);
            this.formStiinta.get('denumire_select')?.patchValue(selectedEntitate.denumire);
            this.formStiinta.get('denumire')?.patchValue(selectedEntitate.denumire);

            if (selectedEntitateType === 2 || selectedEntitateType === 3) {
                this.formStiinta.get('pers_contact')?.patchValue(selectedEntitate.pers_contact);
            }
            if (selectedEntitateType === 1 || selectedEntitateType === 2) {
                this.entitatiStiintaByCNPControl.setValue(selectedEntitate);
                this.formStiinta.get('cnp_cui')?.patchValue(selectedEntitate.cnp_cui);
                this.formStiinta.get('email')?.patchValue(selectedEntitate.email);
                this.formStiinta.get('telefon')?.patchValue(selectedEntitate.telefon);
            }
            if (selectedEntitate.id_tara && selectedEntitate.name_tara) {
                this.tariStiintaControl.setValue({
                    id: selectedEntitate.id_tara,
                    name: selectedEntitate.name_tara
                })
                this.formStiinta.get('id_tara')?.patchValue(selectedEntitate.id_tara);
                this.formStiinta.get('name_tara')?.patchValue(selectedEntitate.name_tara);
                this.loadJudeteStiinta(selectedEntitate.id_tara);
            }
            if (selectedEntitate.id_judet && selectedEntitate.name_judet) {
                this.judeteStiintaControl.setValue({
                    id: selectedEntitate.id_judet,
                    name: selectedEntitate.name_judet
                })
                this.formStiinta.get('id_judet')?.patchValue(selectedEntitate.id_judet);
                this.formStiinta.get('name_judet')?.patchValue(selectedEntitate.name_judet);
            }
            if (selectedEntitate.id_localitate && selectedEntitate.name_localitate) {
                this.fetchLocalitatiStiinta(selectedEntitate.name_localitate);
                this.localitatiStiintaControl.setValue({
                    id: selectedEntitate.id_localitate,
                    name: selectedEntitate.name_localitate
                })
                this.formStiinta.get('id_localitate')?.patchValue(selectedEntitate.id_localitate);
                this.formStiinta.get('name_localitate')?.patchValue(selectedEntitate.name_localitate);
            }
            if (selectedEntitate.id_strada && selectedEntitate.name_strada) {
                this.fetchStraziStiinta(selectedEntitate.name_strada);
                this.straziStiintaControl.setValue({
                    id: selectedEntitate.id_strada,
                    name: selectedEntitate.name_strada
                })
                this.formStiinta.get('id_strada')?.patchValue(selectedEntitate.id_strada);
                this.formStiinta.get('name_strada')?.patchValue(selectedEntitate.name_strada);
            }

            this.formStiinta.get('sector')?.patchValue(selectedEntitate.sector);
            this.formStiinta.get('numar')?.patchValue(selectedEntitate.numar);
            this.formStiinta.get('bloc')?.patchValue(selectedEntitate.bloc);
            this.formStiinta.get('scara')?.patchValue(selectedEntitate.scara);
            this.formStiinta.get('apartament')?.patchValue(selectedEntitate.apartament);
            this.formStiinta.get('cod_postal')?.patchValue(selectedEntitate.cod_postal);
        }
    }

    loadDirectiiActive() {
        this.isLoading = true;
        this.commonService
            .getDirectiiActive()
            .pipe(
                map((results: any) => [...results]),
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.directiiSecundar = results;
                    this.directiiEmitent = results;
                    this.directiiStiinta = results;

                    this.filteredDirectiiSecundar = [...this.directiiSecundar];
                    this.filteredDirectiiEmitent = [...this.directiiEmitent];
                    this.filteredDirectiiStiinta = [...this.directiiStiinta];
                },
                error: (error) => {
                    console.error('Error loading directii', error);
                    this.filteredDirectiiEmitent = [];
                    this.filteredDirectiiSecundar = [];
                    this.filteredDirectiiStiinta = [];
                },
            });
    }

    onDirectiiSecundarChange(selectedCompartiment: Generic): void {
        this.formSecundar.controls['directie_id'].patchValue(selectedCompartiment.id);
        this.formSecundar.controls['directie_name'].patchValue(selectedCompartiment.name);

        this.compartimenteSecundarControl.patchValue('');
        this.formSecundar.controls['compartiment_id'].patchValue('');
        this.formSecundar.controls['compartiment_name'].patchValue('');

        this.operatoriSecundar = [];
        this.filteredOperatoriSecundar = [];
        this.operatoriSecundarControl.patchValue('');
        this.formSecundar.controls['user_id'].patchValue(-1);
        this.formSecundar.controls['user_name'].patchValue('');
    }

    displayDirectiiSecundar(selectedDirectie: Generic): string {
        return selectedDirectie && selectedDirectie.name ? selectedDirectie.name : '';
    }

    onDirectiiSecundarBlur() {
        const currentValue = this.directiiSecundarControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.directiiSecundarControl.patchValue('');
            this.formSecundar.controls['directie_id'].patchValue('');
            this.formSecundar.controls['directie_name'].patchValue('');

            this.compartimenteSecundarControl.patchValue('');
            this.formSecundar.controls['compartiment_id'].patchValue('');
            this.formSecundar.controls['compartiment_name'].patchValue('');

            this.operatoriSecundar = [];
            this.filteredOperatoriSecundar = [];
            this.operatoriSecundarControl.patchValue('');
            this.formSecundar.controls['user_id'].patchValue(-1);
            this.formSecundar.controls['user_name'].patchValue('');
        }
    }

    fetchCompartimenteSecundar(compartiment: string) {
        // const directieSecundarValue = this.formSecundar.get('directie_id')?.value;
        // const directie = directieSecundarValue && directieSecundarValue !== -1 ? directieSecundarValue : undefined;
        if (compartiment.length >= 2) {
            this.isCompartimenteSecundarLoading = true;
            this.commonService.searchCompartimenteActive(undefined, compartiment).subscribe({
                next: (response: any) => {
                    this.compartimenteSecundar = response;
                    this.isCompartimenteSecundarLoading = false;
                    this.compartimenteSecundarLoadComplete = true;
                    this.showCompartimenteSecundarMessage = this.compartimenteSecundar.length === 0;
                },
                error: (err: any) => {
                    this.isCompartimenteSecundarLoading = false;
                    this.showCompartimenteSecundarMessage = true;
                    this.compartimenteSecundarLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.compartimenteSecundar = [];
            this.showCompartimenteSecundarMessage = true;
            this.compartimenteSecundarLoadComplete = false;
        }
    }

    onCompartimenteSecundarSelected(selectedCompartiment: GenericCompartimentSearch): void {
        this.formSecundar.controls['compartiment_id'].patchValue(selectedCompartiment.id);
        this.formSecundar.controls['compartiment_name'].patchValue(selectedCompartiment.name);

        this.directiiSecundarControl.setValue({
            id: selectedCompartiment.directie_id,
            name: selectedCompartiment.directie_name,
        });
        this.formSecundar.controls['directie_id'].patchValue(selectedCompartiment.directie_id);
        this.formSecundar.controls['directie_name'].patchValue(selectedCompartiment.directie_name);

        this.loadOperatoriSecundar();
        this.operatoriSecundarControl.patchValue('');
        this.formSecundar.controls['user_id'].patchValue(-1);
        this.formSecundar.controls['user_name'].patchValue('');
    }

    displayCompartimenteSecundar(selectedCompartiment: GenericCompartimentSearch): string {
        return selectedCompartiment && selectedCompartiment.name ? selectedCompartiment.name : '';
    }

    onCompartimenteSecundarBlur() {
        const currentValue = this.compartimenteSecundarControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.compartimenteSecundarControl.patchValue('');
            this.formSecundar.controls['compartiment_id'].patchValue('');
            this.formSecundar.controls['compartiment_name'].patchValue('');

            this.operatoriSecundar = [];
            this.filteredOperatoriSecundar = [];
            this.operatoriSecundarControl.patchValue('');
            this.formSecundar.controls['user_id'].patchValue(-1);
            this.formSecundar.controls['user_name'].patchValue('');
        }
    }

    loadOperatoriSecundar() {
        this.isLoading = true;
        const payload: UserOrganigramaSearchPayload = {
            directie_id: this.formSecundar.controls['directie_id'].value,
            compartiment_id: this.formSecundar.controls['compartiment_id'].value,
            view_all: 1,
        }
        this.commonService
            .getUsersByOrganigrama(payload)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => { this.isLoading = false })
            ).subscribe({
                next: (data) => {
                    this.operatoriSecundar = [...data];
                    this.filteredOperatoriSecundar = [...this.operatoriSecundar];
                },
                error: (error) => {
                    console.error(error);
                    this.filteredOperatoriSecundar = [];
                },
            });
    }

    // onOperatoriSecundarClosed() {
    //     const selectedValue = this.operatoriSecundarControl.value;

    //     if (selectedValue) {
    //         const isSelectedInFilteredList = this.filteredOperatoriSecundar.some(operator =>
    //             operator.id === this.formSecundar.get('user_id')?.value
    //         );

    //         if (!isSelectedInFilteredList) {
    //             this.operatoriSecundarControl.setValue(null);
    //             this.filteredOperatoriSecundar = this.operatoriSecundar;
    //             this.destroy$.next();
    //             this.destroy$.complete();
    //             this.renderFieldsSearch();
    //         }
    //     }
    // }

    onOperatoriSecundarChange(operatorId: number): void {
        const selectedOperator = this.operatoriSecundar.find(operator => operator.id === operatorId);

        if (selectedOperator) {
            // this.formSecundar.controls['user_id'].patchValue(selectedOperator.id);
            this.formSecundar.controls['user_name'].patchValue(selectedOperator.name);
        }
    }

    // displayOperatoriSecundar(selectedOperator: Generic): string {
    //     return selectedOperator && selectedOperator.name ? selectedOperator.name : '';
    // }

    // onOperatoriSecundarBlur() {
    //     const currentValue = this.operatoriSecundarControl.value;

    //     // If the value is a string (not an object), it means user didn't select from list
    //     if (typeof currentValue === 'string') {
    //         this.operatoriSecundarControl.patchValue('');
    //         this.formSecundar.controls['user_id'].patchValue('');
    //         this.formSecundar.controls['user_name'].patchValue('');
    //     }
    // }

    onDirectiiEmitentChange(selectedCompartiment: Generic): void {
        this.formEmitent.controls['directie_id'].patchValue(selectedCompartiment.id);
        this.formEmitent.controls['directie_name'].patchValue(selectedCompartiment.name);

        this.compartimenteEmitentControl.patchValue('');
        this.formEmitent.controls['compartiment_id'].patchValue('');
        this.formEmitent.controls['compartiment_name'].patchValue('');

        this.operatoriEmitent = [];
        this.filteredOperatoriEmitent = [];
        this.operatoriEmitentControl.patchValue('');
        this.formEmitent.controls['user_id'].patchValue(-1);
        this.formEmitent.controls['user_name'].patchValue('');
    }

    displayDirectiiEmitent(selectedDirectie: Generic): string {
        return selectedDirectie && selectedDirectie.name ? selectedDirectie.name : '';
    }

    onDirectiiEmitentBlur() {
        const currentValue = this.directiiEmitentControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.directiiEmitentControl.patchValue('');
            this.formEmitent.controls['directie_id'].patchValue('');
            this.formEmitent.controls['directie_name'].patchValue('');

            this.compartimenteEmitentControl.patchValue('');
            this.formEmitent.controls['compartiment_id'].patchValue('');
            this.formEmitent.controls['compartiment_name'].patchValue('');

            this.operatoriEmitent = [];
            this.filteredOperatoriEmitent = [];
            this.operatoriEmitentControl.patchValue('');
            this.formEmitent.controls['user_id'].patchValue(-1);
            this.formEmitent.controls['user_name'].patchValue('');
        }
    }

    fetchCompartimenteEmitent(compartiment: string) {
        // const directieEmitentValue = this.formEmitent.get('directie_id')?.value;
        // const directie = directieEmitentValue && directieEmitentValue !== -1 ? directieEmitentValue : undefined;
        if (compartiment.length >= 2) {
            this.isCompartimenteEmitentLoading = true;
            this.commonService.searchCompartimenteActive(undefined, compartiment).subscribe({
                next: (response: any) => {
                    this.compartimenteEmitent = response;
                    this.isCompartimenteEmitentLoading = false;
                    this.compartimenteEmitentLoadComplete = true;
                    this.showCompartimenteEmitentMessage = this.compartimenteEmitent.length === 0;
                },
                error: (err: any) => {
                    this.isCompartimenteEmitentLoading = false;
                    this.showCompartimenteEmitentMessage = true;
                    this.compartimenteEmitentLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.compartimenteEmitent = [];
            this.showCompartimenteEmitentMessage = true;
            this.compartimenteEmitentLoadComplete = false;
        }
    }

    onCompartimenteEmitentSelected(selectedCompartiment: GenericCompartimentSearch): void {
        this.formEmitent.controls['compartiment_id'].patchValue(selectedCompartiment.id);
        this.formEmitent.controls['compartiment_name'].patchValue(selectedCompartiment.name);

        this.directiiEmitentControl.setValue({
            id: selectedCompartiment.directie_id,
            name: selectedCompartiment.directie_name,
        });
        this.formEmitent.controls['directie_id'].patchValue(selectedCompartiment.directie_id);
        this.formEmitent.controls['directie_name'].patchValue(selectedCompartiment.directie_name);

        this.loadOperatoriEmitent();
        this.operatoriEmitentControl.patchValue('');
        this.formEmitent.controls['user_id'].patchValue(-1);
        this.formEmitent.controls['user_name'].patchValue('');
    }

    displayCompartimenteEmitent(selectedCompartiment: GenericCompartimentSearch): string {
        return selectedCompartiment && selectedCompartiment.name ? selectedCompartiment.name : '';
    }

    onCompartimenteEmitentBlur() {
        const currentValue = this.compartimenteEmitentControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.compartimenteEmitentControl.patchValue('');
            this.formEmitent.controls['compartiment_id'].patchValue('');
            this.formEmitent.controls['compartiment_name'].patchValue('');

            this.operatoriEmitent = [];
            this.filteredOperatoriEmitent = [];
            this.operatoriEmitentControl.patchValue('');
            this.formEmitent.controls['user_id'].patchValue(-1);
            this.formEmitent.controls['user_name'].patchValue('');
        }
    }

    loadOperatoriEmitent() {
        this.isLoading = true;
        const payload: UserOrganigramaSearchPayload = {
            directie_id: this.formEmitent.controls['directie_id'].value,
            compartiment_id: this.formEmitent.controls['compartiment_id'].value
        }
        this.commonService
            .getUsersByOrganigrama(payload)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => { this.isLoading = false })
            ).subscribe({
                next: (data) => {
                    this.operatoriEmitent = [...data];
                    this.filteredOperatoriEmitent = [...this.operatoriEmitent];
                },
                error: (error) => {
                    console.error(error);
                    this.filteredOperatoriEmitent = [];
                },
            });
    }

    // onOperatoriEmitentClosed() {
    //     const selectedValue = this.operatoriEmitentControl.value;

    //     if (selectedValue) {
    //         const isSelectedInFilteredList = this.filteredOperatoriEmitent.some(operator =>
    //             operator.id === this.formEmitent.get('user_id')?.value
    //         );

    //         if (!isSelectedInFilteredList) {
    //             this.operatoriEmitentControl.setValue(null);
    //             this.filteredOperatoriEmitent = this.operatoriEmitent;
    //             this.destroy$.next();
    //             this.destroy$.complete();
    //             this.renderFieldsSearch();
    //         }
    //     }
    // }

    onOperatoriEmitentChange(operatorId: number): void {
        const selectedOperator = this.operatoriEmitent.find(operator => operator.id === operatorId);

        if (selectedOperator) {
            // this.formEmitent.controls['user_id'].patchValue(selectedOperator.id);
            this.formEmitent.controls['user_name'].patchValue(selectedOperator.name);
        }
    }

    // displayOperatoriEmitent(selectedOperator: Generic): string {
    //     return selectedOperator && selectedOperator.name ? selectedOperator.name : '';
    // }

    // onOperatoriEmitentBlur() {
    //     const currentValue = this.operatoriEmitentControl.value;

    //     // If the value is a string (not an object), it means user didn't select from list
    //     if (typeof currentValue === 'string') {
    //         this.operatoriEmitentControl.patchValue('');
    //         this.formEmitent.controls['user_id'].patchValue('');
    //         this.formEmitent.controls['user_name'].patchValue('');
    //     }
    // }

    onDirectiiStiintaChange(selectedCompartiment: Generic): void {
        this.formStiinta.controls['directie_id'].patchValue(selectedCompartiment.id);
        this.formStiinta.controls['directie_name'].patchValue(selectedCompartiment.name);

        this.compartimenteStiintaControl.patchValue('');
        this.formStiinta.controls['compartiment_id'].patchValue('');
        this.formStiinta.controls['compartiment_name'].patchValue('');

        this.operatoriStiinta = [];
        this.filteredOperatoriStiinta = [];
        this.operatoriStiintaControl.patchValue('');
        this.formStiinta.controls['user_id'].patchValue(-1);
        this.formStiinta.controls['user_name'].patchValue('');
    }

    displayDirectiiStiinta(selectedDirectie: Generic): string {
        return selectedDirectie && selectedDirectie.name ? selectedDirectie.name : '';
    }

    onDirectiiStiintaBlur() {
        const currentValue = this.directiiStiintaControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.directiiStiintaControl.patchValue('');
            this.formStiinta.controls['directie_id'].patchValue('');
            this.formStiinta.controls['directie_name'].patchValue('');

            this.compartimenteStiintaControl.patchValue('');
            this.formStiinta.controls['compartiment_id'].patchValue('');
            this.formStiinta.controls['compartiment_name'].patchValue('');

            this.operatoriStiinta = [];
            this.filteredOperatoriStiinta = [];
            this.operatoriStiintaControl.patchValue('');
            this.formStiinta.controls['user_id'].patchValue(-1);
            this.formStiinta.controls['user_name'].patchValue('');
        }
    }

    fetchCompartimenteStiinta(compartiment: string) {
        // const directieStiintaValue = this.formStiinta.get('directie_id')?.value;
        // const directie = directieStiintaValue && directieStiintaValue !== -1 ? directieStiintaValue : undefined;
        if (compartiment.length >= 2) {
            this.isCompartimenteStiintaLoading = true;
            this.commonService.searchCompartimenteActive(undefined, compartiment).subscribe({
                next: (response: any) => {
                    this.compartimenteStiinta = response;
                    this.isCompartimenteStiintaLoading = false;
                    this.compartimenteStiintaLoadComplete = true;
                    this.showCompartimenteStiintaMessage = this.compartimenteStiinta.length === 0;
                },
                error: (err: any) => {
                    this.isCompartimenteStiintaLoading = false;
                    this.showCompartimenteStiintaMessage = true;
                    this.compartimenteStiintaLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.compartimenteStiinta = [];
            this.showCompartimenteStiintaMessage = true;
            this.compartimenteStiintaLoadComplete = false;
        }
    }

    onCompartimenteStiintaSelected(selectedCompartiment: GenericCompartimentSearch): void {
        this.formStiinta.controls['compartiment_id'].patchValue(selectedCompartiment.id);
        this.formStiinta.controls['compartiment_name'].patchValue(selectedCompartiment.name);

        this.directiiStiintaControl.setValue({
            id: selectedCompartiment.directie_id,
            name: selectedCompartiment.directie_name,
        });
        this.formStiinta.controls['directie_id'].patchValue(selectedCompartiment.directie_id);
        this.formStiinta.controls['directie_name'].patchValue(selectedCompartiment.directie_name);

        this.loadOperatoriStiinta();
        this.operatoriStiintaControl.patchValue('');
        this.formStiinta.controls['user_id'].patchValue(-1);
        this.formStiinta.controls['user_name'].patchValue('');
    }

    displayCompartimenteStiinta(selectedCompartiment: GenericCompartimentSearch): string {
        return selectedCompartiment && selectedCompartiment.name ? selectedCompartiment.name : '';
    }

    onCompartimenteStiintaBlur() {
        const currentValue = this.compartimenteStiintaControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.compartimenteStiintaControl.patchValue('');
            this.formStiinta.controls['compartiment_id'].patchValue('');
            this.formStiinta.controls['compartiment_name'].patchValue('');

            this.operatoriStiinta = [];
            this.filteredOperatoriStiinta = [];
            this.operatoriStiintaControl.patchValue('');
            this.formStiinta.controls['user_id'].patchValue(-1);
            this.formStiinta.controls['user_name'].patchValue('');
        }
    }

    loadOperatoriStiinta() {
        this.isLoading = true;
        const payload: UserOrganigramaSearchPayload = {
            directie_id: this.formStiinta.controls['directie_id'].value,
            compartiment_id: this.formStiinta.controls['compartiment_id'].value
        }
        this.commonService
            .getUsersByOrganigrama(payload)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => { this.isLoading = false })
            ).subscribe({
                next: (data) => {
                    this.operatoriStiinta = [...data];
                    this.filteredOperatoriStiinta = [...this.operatoriStiinta];
                },
                error: (error) => {
                    console.error(error);
                    this.filteredOperatoriStiinta = [];
                },
            });
    }

    // onOperatoriStiintaClosed() {
    //     const selectedValue = this.operatoriStiintaControl.value;

    //     if (selectedValue) {
    //         const isSelectedInFilteredList = this.filteredOperatoriStiinta.some(operator =>
    //             operator.id === this.formStiinta.get('user_id')?.value
    //         );

    //         if (!isSelectedInFilteredList) {
    //             this.operatoriStiintaControl.setValue(null);
    //             this.filteredOperatoriStiinta = this.operatoriStiinta;
    //             this.destroy$.next();
    //             this.destroy$.complete();
    //             this.renderFieldsSearch();
    //         }
    //     }
    // }

    onOperatoriStiintaChange(operatorId: number): void {
        const selectedOperator = this.operatoriStiinta.find(operator => operator.id === operatorId);

        if (selectedOperator) {
            // this.formStiinta.controls['user_id'].patchValue(selectedOperator.id);
            this.formStiinta.controls['user_name'].patchValue(selectedOperator.name);
        }
    }

    // displayOperatoriStiinta(selectedOperator: Generic): string {
    //     return selectedOperator && selectedOperator.name ? selectedOperator.name : '';
    // }

    // onOperatoriStiintaBlur() {
    //     const currentValue = this.operatoriStiintaControl.value;

    //     // If the value is a string (not an object), it means user didn't select from list
    //     if (typeof currentValue === 'string') {
    //         this.operatoriStiintaControl.patchValue('');
    //         this.formStiinta.controls['user_id'].patchValue('');
    //         this.formStiinta.controls['user_name'].patchValue('');
    //     }
    // }

    loadTariActive() {
        this.isLoading = true;
        this.commonService
            .getTariActive()
            .pipe(
                takeUntil(this.destroy$),
                map((resp: Generic[]) => [...resp]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.tariEmitent = results;
                    this.tariStiinta = results;

                    this.filteredTariEmitent = [...this.tariEmitent];
                    this.filteredTariStiinta = [...this.tariStiinta];
                },
                error: (error) => {
                    console.error('Error loading tari', error);
                    this.filteredTariEmitent = [];
                    this.filteredTariStiinta = [];
                },
            });
    }

    onTariEmitentChange(selectedTara: Generic): void {
        this.formEmitent.controls['id_tara'].patchValue(selectedTara.id);
        this.formEmitent.controls['name_tara'].patchValue(selectedTara.name);

        this.loadJudeteEmitent(selectedTara.id);
        this.judeteEmitentControl.patchValue('');
        this.formEmitent.controls['id_judet'].patchValue('');
        this.formEmitent.controls['name_judet'].patchValue('');

        this.localitatiEmitentControl.patchValue('');
        this.formEmitent.controls['id_localitate'].patchValue('');
        this.formEmitent.controls['name_localitate'].patchValue('');

        this.straziEmitentControl.patchValue('');
        this.formEmitent.controls['id_strada'].patchValue('');
        this.formEmitent.controls['name_strada'].patchValue('');
    }

    displayTariEmitent(selectedTara: Generic): string {
        return selectedTara && selectedTara.name ? selectedTara.name : '';
    }

    onTariEmitentBlur() {
        const currentValue = this.tariEmitentControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.tariEmitentControl.patchValue('');
            this.formEmitent.controls['id_tara'].patchValue('');
            this.formEmitent.controls['name_tara'].patchValue('');

            this.judeteEmitent = [];
            this.filteredJudeteEmitent = [];
            this.judeteEmitentControl.patchValue('');
            this.formEmitent.controls['id_judet'].patchValue('');
            this.formEmitent.controls['name_judet'].patchValue('');

            this.localitatiEmitentControl.patchValue('');
            this.formEmitent.controls['id_localitate'].patchValue('');
            this.formEmitent.controls['name_localitate'].patchValue('');

            this.straziEmitentControl.patchValue('');
            this.formEmitent.controls['id_strada'].patchValue('');
            this.formEmitent.controls['name_strada'].patchValue('');
        }
    }

    loadJudeteEmitent(taraId?: number) {
        this.isLoading = true;
        this.commonService
            .getJudeteActive(taraId)
            .pipe(
                takeUntil(this.destroy$),
                map((resp: Generic[]) => [...resp]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.judeteEmitent = results;
                    this.filteredJudeteEmitent = results;
                },
                error: (error) => {
                    console.error('Error loading judete', error);
                    this.filteredJudeteEmitent = [];
                },
            });
    }

    onJudeteEmitentChange(selectedJudet: Generic): void {
        this.formEmitent.controls['id_judet'].patchValue(selectedJudet.id);
        this.formEmitent.controls['name_judet'].patchValue(selectedJudet.name);

        this.localitatiEmitentControl.patchValue('');
        this.formEmitent.controls['id_localitate'].patchValue('');
        this.formEmitent.controls['name_localitate'].patchValue('');

        this.straziEmitentControl.patchValue('');
        this.formEmitent.controls['id_strada'].patchValue('');
        this.formEmitent.controls['name_strada'].patchValue('');
    }

    displayJudeteEmitent(selectedJudet: Generic): string {
        return selectedJudet && selectedJudet.name ? selectedJudet.name : '';
    }

    onJudeteEmitentBlur() {
        const currentValue = this.judeteEmitentControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.judeteEmitentControl.patchValue('');
            this.formEmitent.controls['id_judet'].patchValue('');
            this.formEmitent.controls['name_judet'].patchValue('');

            this.localitatiEmitentControl.patchValue('');
            this.formEmitent.controls['id_localitate'].patchValue('');
            this.formEmitent.controls['name_localitate'].patchValue('');

            this.straziEmitentControl.patchValue('');
            this.formEmitent.controls['id_strada'].patchValue('');
            this.formEmitent.controls['name_strada'].patchValue('');
        }
    }

    fetchLocalitatiEmitent(localitate: string) {
        const taraEmitentValue = this.formEmitent.get('id_tara')?.value;
        const judetEmitentValue = this.formEmitent.get('id_judet')?.value;
        const tara = taraEmitentValue && taraEmitentValue !== -1 ? this.formEmitent.get('id_tara')?.value : undefined;
        const judet = judetEmitentValue && judetEmitentValue !== -1 ? this.formEmitent.get('id_judet')?.value : undefined;
        if (localitate.length >= 2) {
            this.isLocalitatiEmitentLoading = true;
            this.commonService.getLocalitatiActive(tara, judet, localitate).subscribe({
                next: (response: any) => {
                    this.localitatiEmitent = response;
                    this.isLocalitatiEmitentLoading = false;
                    this.localitatiEmitentLoadComplete = true;
                    this.showLocalitatiEmitentMessage = this.localitatiEmitent.length === 0;
                },
                error: (err: any) => {
                    this.isLocalitatiEmitentLoading = false;
                    this.showLocalitatiEmitentMessage = true;
                    this.localitatiEmitentLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.localitatiEmitent = [];
            this.showLocalitatiEmitentMessage = true;
            this.localitatiEmitentLoadComplete = false;
        }
    }

    onLocalitatiEmitentSelected(selectedLocalitate: Generic) {
        if (selectedLocalitate) {
            this.formEmitent.controls['id_localitate'].patchValue(selectedLocalitate.id);
            this.formEmitent.controls['name_localitate'].patchValue(selectedLocalitate.name);
        }
    }

    displayLocalitatiEmitent(selectedLocalitate: Generic): string {
        return selectedLocalitate && selectedLocalitate.name ? selectedLocalitate.name : '';
    }

    onLocalitatiEmitentBlur() {
        const currentValue = this.localitatiEmitentControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.localitatiEmitentControl.patchValue('');
            this.formEmitent.controls['id_localitate'].patchValue('');
            this.formEmitent.controls['name_localitate'].patchValue('');

            this.straziEmitentControl.patchValue('');
            this.formEmitent.controls['id_strada'].patchValue('');
            this.formEmitent.controls['name_strada'].patchValue('');
        }
    }

    fetchStraziEmitent(strada: string) {
        this.fetchStraziEmitentObservable(strada).subscribe();
    }

    private fetchStraziEmitentObservable(strada: string) {
        const taraEmitentValue = this.formEmitent.get('id_tara')?.value;
        const judetEmitentValue = this.formEmitent.get('id_judet')?.value;
        const localitateEmitentValue = this.formEmitent.get('id_localitate')?.value;
        const tara = taraEmitentValue && taraEmitentValue !== -1 ? taraEmitentValue : undefined;
        const judet = judetEmitentValue && judetEmitentValue !== -1 ? judetEmitentValue : undefined;
        const localitate = localitateEmitentValue && localitateEmitentValue !== -1 ? localitateEmitentValue : undefined;

        if (strada.length >= 2) {
            this.lastStraziEmitentValue = strada;
            this.isStraziEmitentLoading = true;

            return this.commonService.getStraziActive(tara, judet, localitate, strada).pipe(
                takeUntil(this.destroy$),
                tap((response: any) => {
                    this.straziEmitent = response;
                    this.isStraziEmitentLoading = false;
                    this.straziEmitentLoadComplete = true;
                    this.showStraziEmitentMessage = this.straziEmitent.length === 0;
                }),
                catchError((err: any) => {
                    this.isStraziEmitentLoading = false;
                    this.showStraziEmitentMessage = true;
                    this.straziEmitentLoadComplete = true;
                    console.log(err);
                    return throwError(() => err);
                })
            );
        } else {
            this.straziEmitent = [];
            this.showStraziEmitentMessage = true;
            this.straziEmitentLoadComplete = false;
            return of([]);
        }
    }

    onStraziEmitentSelected(selectedStrada: Generic) {
        if (selectedStrada) {
            this.formEmitent.controls['id_strada'].patchValue(selectedStrada.id);
            this.formEmitent.controls['name_strada'].patchValue(selectedStrada.name);
        }
    }

    displayStraziEmitent(selectedStrada: Generic): string {
        return selectedStrada && selectedStrada.name ? selectedStrada.name : '';
    }

    onStraziEmitentBlur() {
        setTimeout(() => {
            const currentValue = this.straziEmitentControl.value;

            // If the value is a string (not an object), it means user didn't select from list
            if (typeof currentValue === 'string') {
                this.straziEmitentControl.patchValue('');
                this.formEmitent.controls['id_strada'].patchValue('');
                this.formEmitent.controls['name_strada'].patchValue('');
                this.lastStraziEmitentValue = '';
            }
        }, 2000);
    }

    addStraziEmitent() {
        this.isLoading = true;
        const payload = {
            name: this.lastStraziEmitentValue,
            id_country: this.formEmitent.get('id_tara')?.value,
            id_judet: this.formEmitent.get('id_judet')?.value,
            id_localitate: this.formEmitent.get('id_localitate')?.value,
        }

        // console.log(payload);
        this.commonService.storeStrada(payload)
            .pipe(
                switchMap(() => this.fetchStraziEmitentObservable(this.lastStraziEmitentValue)),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: () => {
                    // Run fetchStraziEmitent first then fill the input with the new street data
                    if (this.straziEmitent && this.straziEmitent.length > 0) {
                        const foundStrada = this.straziEmitent[0];
                        this.straziEmitentControl.setValue(foundStrada);
                        this.formEmitent.controls['id_strada'].patchValue(foundStrada.id);
                        this.formEmitent.controls['name_strada'].patchValue(foundStrada.name);
                    }
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            })
    }

    onTariStiintaChange(selectedTara: Generic): void {
        this.formStiinta.controls['id_tara'].patchValue(selectedTara.id);
        this.formStiinta.controls['name_tara'].patchValue(selectedTara.name);

        this.loadJudeteStiinta(selectedTara.id);
        this.judeteStiintaControl.patchValue('');
        this.formStiinta.controls['id_judet'].patchValue('');
        this.formStiinta.controls['name_judet'].patchValue('');

        this.localitatiStiintaControl.patchValue('');
        this.formStiinta.controls['id_localitate'].patchValue('');
        this.formStiinta.controls['name_localitate'].patchValue('');

        this.straziStiintaControl.patchValue('');
        this.formStiinta.controls['id_strada'].patchValue('');
        this.formStiinta.controls['name_strada'].patchValue('');
    }

    displayTariStiinta(selectedTara: Generic): string {
        return selectedTara && selectedTara.name ? selectedTara.name : '';
    }

    onTariStiintaBlur() {
        const currentValue = this.tariStiintaControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.tariStiintaControl.patchValue('');
            this.formStiinta.controls['id_tara'].patchValue('');
            this.formStiinta.controls['name_tara'].patchValue('');

            this.judeteStiinta = [];
            this.filteredJudeteStiinta = [];
            this.judeteStiintaControl.patchValue('');
            this.formStiinta.controls['id_judet'].patchValue('');
            this.formStiinta.controls['name_judet'].patchValue('');

            this.localitatiStiintaControl.patchValue('');
            this.formStiinta.controls['id_localitate'].patchValue('');
            this.formStiinta.controls['name_localitate'].patchValue('');

            this.straziStiintaControl.patchValue('');
            this.formStiinta.controls['id_strada'].patchValue('');
            this.formStiinta.controls['name_strada'].patchValue('');
        }
    }

    loadJudeteStiinta(taraId?: number) {
        this.isLoading = true;
        this.commonService
            .getJudeteActive(taraId)
            .pipe(
                takeUntil(this.destroy$),
                map((resp: Generic[]) => [...resp]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.judeteStiinta = results;
                    this.filteredJudeteStiinta = results;
                },
                error: (error) => {
                    console.error('Error loading judete', error);
                    this.filteredJudeteStiinta = [];
                },
            });
    }

    onJudeteStiintaChange(selectedJudet: Generic): void {
        this.formStiinta.controls['id_judet'].patchValue(selectedJudet.id);
        this.formStiinta.controls['name_judet'].patchValue(selectedJudet.name);

        this.localitatiStiintaControl.patchValue('');
        this.formStiinta.controls['id_localitate'].patchValue('');
        this.formStiinta.controls['name_localitate'].patchValue('');

        this.straziStiintaControl.patchValue('');
        this.formStiinta.controls['id_strada'].patchValue('');
        this.formStiinta.controls['name_strada'].patchValue('');
    }

    displayJudeteStiinta(selectedJudet: Generic): string {
        return selectedJudet && selectedJudet.name ? selectedJudet.name : '';
    }

    onJudeteStiintaBlur() {
        const currentValue = this.judeteStiintaControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.judeteStiintaControl.patchValue('');
            this.formStiinta.controls['id_judet'].patchValue('');
            this.formStiinta.controls['name_judet'].patchValue('');

            this.localitatiStiintaControl.patchValue('');
            this.formStiinta.controls['id_localitate'].patchValue('');
            this.formStiinta.controls['name_localitate'].patchValue('');

            this.straziStiintaControl.patchValue('');
            this.formStiinta.controls['id_strada'].patchValue('');
            this.formStiinta.controls['name_strada'].patchValue('');
        }
    }

    fetchLocalitatiStiinta(localitate: string) {
        const taraStiintaValue = this.formStiinta.get('id_tara')?.value;
        const judetStiintaValue = this.formStiinta.get('id_judet')?.value;
        const tara = taraStiintaValue && taraStiintaValue !== -1 ? this.formStiinta.get('id_tara')?.value : undefined;
        const judet = judetStiintaValue && judetStiintaValue !== -1 ? this.formStiinta.get('id_judet')?.value : undefined;
        if (localitate.length >= 2) {
            this.isLocalitatiStiintaLoading = true;
            this.commonService.getLocalitatiActive(tara, judet, localitate).subscribe({
                next: (response: any) => {
                    this.localitatiStiinta = response;
                    this.isLocalitatiStiintaLoading = false;
                    this.localitatiStiintaLoadComplete = true;
                    this.showLocalitatiStiintaMessage = this.localitatiStiinta.length === 0;
                },
                error: (err: any) => {
                    this.isLocalitatiStiintaLoading = false;
                    this.showLocalitatiStiintaMessage = true;
                    this.localitatiStiintaLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.localitatiStiinta = [];
            this.showLocalitatiStiintaMessage = true;
            this.localitatiStiintaLoadComplete = false;
        }
    }

    onLocalitatiStiintaSelected(selectedLocalitate: Generic) {
        if (selectedLocalitate) {
            this.formStiinta.controls['id_localitate'].patchValue(selectedLocalitate.id);
            this.formStiinta.controls['name_localitate'].patchValue(selectedLocalitate.name);
        }
    }

    displayLocalitatiStiinta(selectedLocalitate: Generic): string {
        return selectedLocalitate && selectedLocalitate.name ? selectedLocalitate.name : '';
    }

    onLocalitatiStiintaBlur() {
        const currentValue = this.localitatiStiintaControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.localitatiStiintaControl.patchValue('');
            this.formStiinta.controls['id_localitate'].patchValue('');
            this.formStiinta.controls['name_localitate'].patchValue('');

            this.straziStiintaControl.patchValue('');
            this.formStiinta.controls['id_strada'].patchValue('');
            this.formStiinta.controls['name_strada'].patchValue('');
        }
    }

    fetchStraziStiinta(strada: string) {
        this.fetchStraziStiintaObservable(strada).subscribe();
    }

    private fetchStraziStiintaObservable(strada: string) {
        const taraStiintaValue = this.formStiinta.get('id_tara')?.value;
        const judetStiintaValue = this.formStiinta.get('id_judet')?.value;
        const localitateStiintaValue = this.formStiinta.get('id_localitate')?.value;
        const tara = taraStiintaValue && taraStiintaValue !== -1 ? taraStiintaValue : undefined;
        const judet = judetStiintaValue && judetStiintaValue !== -1 ? judetStiintaValue : undefined;
        const localitate = localitateStiintaValue && localitateStiintaValue !== -1 ? localitateStiintaValue : undefined;

        if (strada.length >= 2) {
            this.lastStraziStiintaValue = strada;
            this.isStraziStiintaLoading = true;

            return this.commonService.getStraziActive(tara, judet, localitate, strada).pipe(
                takeUntil(this.destroy$),
                tap((response: any) => {
                    this.straziStiinta = response;
                    this.isStraziStiintaLoading = false;
                    this.straziStiintaLoadComplete = true;
                    this.showStraziStiintaMessage = this.straziStiinta.length === 0;
                }),
                catchError((err: any) => {
                    this.isStraziStiintaLoading = false;
                    this.showStraziStiintaMessage = true;
                    this.straziStiintaLoadComplete = true;
                    console.log(err);
                    return throwError(() => err);
                })
            );
        } else {
            this.straziStiinta = [];
            this.showStraziStiintaMessage = true;
            this.straziStiintaLoadComplete = false;
            return of([]);
        }
    }

    onStraziStiintaSelected(selectedStrada: Generic) {
        if (selectedStrada) {
            this.formStiinta.controls['id_strada'].patchValue(selectedStrada.id);
            this.formStiinta.controls['name_strada'].patchValue(selectedStrada.name);
        }
    }

    displayStraziStiinta(selectedStrada: Generic): string {
        return selectedStrada && selectedStrada.name ? selectedStrada.name : '';
    }

    onStraziStiintaBlur() {
        setTimeout(() => {
            const currentValue = this.straziStiintaControl.value;

            // If the value is a string (not an object), it means user didn't select from list
            if (typeof currentValue === 'string') {
                this.straziStiintaControl.patchValue('');
                this.formStiinta.controls['id_strada'].patchValue('');
                this.formStiinta.controls['name_strada'].patchValue('');
                this.lastStraziStiintaValue = '';
            }
        }, 2000);
    }

    addStraziStiinta() {
        this.isLoading = true;
        const payload = {
            name: this.lastStraziStiintaValue,
            id_country: this.formStiinta.get('id_tara')?.value,
            id_judet: this.formStiinta.get('id_judet')?.value,
            id_localitate: this.formStiinta.get('id_localitate')?.value,
        }

        // console.log(payload);
        this.commonService.storeStrada(payload)
            .pipe(
                switchMap(() => this.fetchStraziStiintaObservable(this.lastStraziStiintaValue)),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: () => {
                    // Run fetchStraziStiinta first then fill the input with the new street data
                    if (this.straziStiinta && this.straziStiinta.length > 0) {
                        const foundStrada = this.straziStiinta[0];
                        this.straziStiintaControl.setValue(foundStrada);
                        this.formStiinta.controls['id_strada'].patchValue(foundStrada.id);
                        this.formStiinta.controls['name_strada'].patchValue(foundStrada.name);
                    }
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            })
    }

    normalizeString(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    filterDirectiiSecundar(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.directiiSecundar.filter(directie =>
            this.normalizeString(directie.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterOperatoriSecundar(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.operatoriSecundar.filter(compartiment =>
            this.normalizeString(compartiment.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterDirectiiEmitent(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.directiiEmitent.filter(directie =>
            this.normalizeString(directie.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterOperatoriEmitent(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.operatoriEmitent.filter(compartiment =>
            this.normalizeString(compartiment.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterTariEmitent(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.tariEmitent.filter(tara =>
            this.normalizeString(tara.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterJudeteEmitent(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.judeteEmitent.filter(judet =>
            this.normalizeString(judet.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterDirectiiStiinta(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.directiiStiinta.filter(directie =>
            this.normalizeString(directie.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterOperatoriStiinta(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.operatoriStiinta.filter(compartiment =>
            this.normalizeString(compartiment.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterTariStiinta(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.tariStiinta.filter(tara =>
            this.normalizeString(tara.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterJudeteStiinta(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.judeteStiinta.filter(judet =>
            this.normalizeString(judet.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }
    // END -- Methods for getting data -- END


    onRegisteActiveSelected(registruActiveId: number) {
        // const registratura_number_type = this.form.get('registratura_number_type') as FormControl;
        // const registratura_number = this.form.get('registratura_number') as FormControl;
        // const exit_document_format = this.form.get('exit_document_format') as FormControl;

        // const files = this.formFiles.get('files') as FormArray;

        // if (registruActiveId !== this.registruOficialGeneralValue) {
        //     registratura_number_type.setValidators([Validators.required, notDefaultValidator('-1')]);
        //     registratura_number_type.markAsUntouched();
        //     this.showRegistreFields = true;

        //     exit_document_format.setValidators([Validators.required, notDefaultValidator('-1')]);
        //     exit_document_format.markAsUntouched();
        //     this.showProceduraField = true;
        // } else {
        //     registratura_number_type.patchValue(1); // Default number_type
        //     registratura_number_type.clearValidators();
        //     registratura_number_type.setErrors(null);
        //     registratura_number_type.markAsUntouched();
        //     this.showRegistreFields = false;

        //     exit_document_format.patchValue(-1);
        //     exit_document_format.clearValidators();
        //     exit_document_format.setErrors(null);
        //     exit_document_format.markAsUntouched();
        //     this.showProceduraField = false;
        // }

        // if (this.showRegistreFields === false) {
        //     registratura_number.patchValue('');
        //     registratura_number.clearValidators();
        //     registratura_number.setErrors(null);
        //     registratura_number.markAsUntouched();
        // }
        // if (this.showProceduraField === false) {
        //     files.clear();
        //     files.clearValidators();
        //     files.setErrors(null);
        //     files.markAsUntouched();
        //     this.showFormFiles = false;
        // }

        // this.form.updateValueAndValidity();
    }

    onRegistraturaTypeSelected(registraturaType: number) {
        const registratura_number = this.form.get('registratura_number') as FormControl;

        if (registraturaType === 2) {
            registratura_number.setValidators([Validators.required]);
            registratura_number.markAsUntouched();
        } else {
            registratura_number.patchValue('');
            registratura_number.clearValidators();
            registratura_number.setErrors(null);
            registratura_number.markAsUntouched();
        }

        this.form.updateValueAndValidity();
    }

    onProceduraIesireSelected(proceduraIesire: number) {
        const files = this.formFiles.get('files') as FormArray;

        if (proceduraIesire === 2) {
            files.setValidators([Validators.required]);
            files.markAsUntouched();
            this.showFormFiles = true;
        } else {
            files.clear();
            files.clearValidators();
            files.setErrors(null);
            files.markAsUntouched();
            this.showFormFiles = false;
        }

        this.formFiles.updateValueAndValidity();
    }

    addSerie() {
        const sourceValue: number = this.form.controls['source'].value;

        if (!sourceValue || sourceValue === -1) return;

        const existing = this.sourceArr.find((item: Sursa) => item.id === sourceValue);

        if (existing) {
            return;
        } else {
            const sursa = this.surse.find((item: Generic) => item.id === sourceValue);
            if (sursa) {
                const sourceItem = {
                    id: sursa.id,
                    name: sursa.name,
                }
                this.sourceArr.push(sourceItem);
            };
        }
    }

    removeSerie(index: number) {
        this.sourceArr.splice(index, 1);
    }

    resetFormEmitent(entitateType: number) {
        const cnp_cui = this.formEmitent.get('cnp_cui') as FormControl;

        if (entitateType === 1 || entitateType === 2) {
            cnp_cui.setValidators([Validators.required]);
            cnp_cui.markAsUntouched();
        } else {
            cnp_cui.patchValue('');
            cnp_cui.clearValidators();
            cnp_cui.setErrors(null);
            cnp_cui.markAsUntouched();
        }

        this.formEmitent.patchValue({
            type: 1, // Hard coded emitent
            id: null,
            // id_address_type: -1,
            denumire: '',
            pers_contact: '',
            denumire_select: '',
            directie_id: null,
            directie_name: '',
            compartiment_id: null,
            compartiment_name: '',
            user_id: -1,
            user_name: '',
            cnp_cui: '',
            email: '',
            telefon: '',
            id_tara: this.defaultTaraId,
            name_tara: this.defaultTaraLabel,
            id_judet: this.defaultJudetId,
            name_judet: this.defaultJudetLabel,
            id_localitate: this.defaultLocalitateId,
            name_localitate: this.defaultLocalitateLabel,
            sector: '-1',
            id_strada: null,
            name_strada: '',
            numar: '',
            bloc: '',
            scara: '',
            apartament: '',
            cod_postal: '',
            numar_deces: '',
            data_deces_input: '',
            person_status: false,
            observatii: '',
        });
        this.resetFormEmitentFields();

        this.formEmitent.updateValueAndValidity();
    }
    resetFormEmitentFields() {
        this.entitatiEmitent = [];
        this.entitatiEmitentByCNP = [];
        this.entitatiEmitentControl.setValue('');
        this.entitatiEmitentByCNPControl.setValue('');

        this.filteredDirectiiEmitent = this.directiiEmitent;
        this.directiiEmitentControl.setValue('');

        this.compartimenteEmitent = [];
        this.compartimenteEmitentControl.setValue('');

        this.operatoriEmitent = [];
        this.filteredOperatoriEmitent = [];
        this.operatoriEmitentControl.setValue('');

        this.filteredTariEmitent = this.tariEmitent;
        this.tariEmitentControl.setValue('');

        this.judeteEmitent = [];
        this.filteredJudeteEmitent = [];
        this.judeteEmitentControl.setValue('');

        this.localitatiEmitent = [];
        this.localitatiEmitentControl.setValue('')

        this.straziEmitent = [];
        this.straziEmitentControl.setValue('')

        this.destroy$.next();
        this.destroy$.complete();
        this.renderFieldsSearch();

        this.loadDefaultLocatieEmitent();
    }
    loadDefaultLocatieEmitent() {
        this.tariEmitentControl.setValue({
            id: this.defaultTaraId,
            name: this.defaultTaraLabel
        })
        if (this.defaultTaraId) {
            this.loadJudeteEmitent(this.defaultTaraId);
            this.judeteEmitentControl.setValue({
                id: this.defaultJudetId,
                name: this.defaultJudetLabel
            })
        }
        if (this.defaultJudetLabel) {
            this.fetchLocalitatiEmitent(this.defaultJudetLabel);
            this.localitatiEmitentControl.setValue({
                id: this.defaultLocalitateId,
                name: this.defaultLocalitateLabel
            })
        }

        this.formEmitent.patchValue({
            id_tara: this.defaultTaraId,
            name_tara: this.defaultTaraLabel,
            id_judet: this.defaultJudetId,
            name_judet: this.defaultJudetLabel,
            id_localitate: this.defaultLocalitateId,
            name_localitate: this.defaultLocalitateLabel,
        })
    }

    toggleStiintaFullForm() {
        this.showStiintaFullForm = !this.showStiintaFullForm;
    }
    toggleStiintaInfoForm() {
        this.showStiintaInfoForm = !this.showStiintaInfoForm;
    }

    resetFormStiinta(entitateType: number) {
        this.formStiinta.patchValue({
            type: 2, // Hard coded stiinta
            key: null,
            id: null,
            // id_address_type: -1,
            denumire: '',
            pers_contact: '',
            denumire_select: '',
            directie_id: null,
            directie_name: '',
            compartiment_id: null,
            compartiment_name: '',
            user_id: -1,
            user_name: '',
            cnp_cui: '',
            email: '',
            telefon: '',
            id_tara: this.defaultTaraId,
            name_tara: this.defaultTaraLabel,
            id_judet: this.defaultJudetId,
            name_judet: this.defaultJudetLabel,
            id_localitate: this.defaultLocalitateId,
            name_localitate: this.defaultLocalitateLabel,
            sector: '-1',
            id_strada: null,
            name_strada: '',
            numar: '',
            bloc: '',
            scara: '',
            apartament: '',
            cod_postal: '',
            observatii: '',
        });
        this.resetFormStiintaFields();

        this.formStiinta.updateValueAndValidity();
    }
    resetFormStiintaFields() {
        this.entitatiStiinta = [];
        this.entitatiStiintaByCNP = [];
        this.entitatiStiintaControl.setValue('');
        this.entitatiStiintaByCNPControl.setValue('');

        this.filteredDirectiiStiinta = this.directiiStiinta;
        this.directiiStiintaControl.setValue('');

        this.compartimenteStiinta = [];
        this.compartimenteStiintaControl.setValue('');

        this.operatoriStiinta = [];
        this.filteredOperatoriStiinta = [];
        this.operatoriStiintaControl.setValue('');

        this.filteredTariStiinta = this.tariStiinta;
        this.tariStiintaControl.setValue('');

        this.judeteStiinta = [];
        this.filteredJudeteStiinta = [];
        this.judeteStiintaControl.setValue('');

        this.localitatiStiinta = [];
        this.localitatiStiintaControl.setValue('')

        this.straziStiinta = [];
        this.straziStiintaControl.setValue('')

        this.destroy$.next();
        this.destroy$.complete();
        this.renderFieldsSearch();

        this.loadDefaultLocatieStiinta();
    }
    loadDefaultLocatieStiinta() {
        this.tariStiintaControl.setValue({
            id: this.defaultTaraId,
            name: this.defaultTaraLabel
        })
        if (this.defaultTaraId) {
            this.loadJudeteStiinta(this.defaultTaraId);
            this.judeteStiintaControl.setValue({
                id: this.defaultJudetId,
                name: this.defaultJudetLabel
            })
        }
        if (this.defaultJudetLabel) {
            this.fetchLocalitatiStiinta(this.defaultJudetLabel);
            this.localitatiStiintaControl.setValue({
                id: this.defaultLocalitateId,
                name: this.defaultLocalitateLabel
            })
        }

        this.formStiinta.patchValue({
            id_tara: this.defaultTaraId,
            name_tara: this.defaultTaraLabel,
            id_judet: this.defaultJudetId,
            name_judet: this.defaultJudetLabel,
            id_localitate: this.defaultLocalitateId,
            name_localitate: this.defaultLocalitateLabel,
        })
    }

    addStiintaRecord() {
        const formStiintaValue = this.formStiinta.value;
        const { id, id_address_type, denumire_select, denumire, directie_name, compartiment_name } = formStiintaValue;

        if (id) {
            // Searched record
            const isExistingRecordId = this.toStiintaRecords.some(record => id_address_type === record.id_address_type && id === record.id)

            if (isExistingRecordId) {
                return
            }
        } else {
            // Non searched record
            if (
                id_address_type !== 4 && !denumire_select && !denumire ||
                id_address_type === 4 && !directie_name && !compartiment_name
            ) {
                return
            }
        }

        this.toStiintaRecords.push(formStiintaValue);

        // Reset back to cetatean
        this.formStiinta.get('id_address_type')?.patchValue(1);
        this.resetFormStiinta(1);
    }

    deleteStiintaRecord(index: number) {
        this.toStiintaRecords.splice(index, 1);
    }

    addFile(event: any) {
        event.preventDefault();
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        // Iterate through the selected files and append them to the 'files' array in the form
        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            // Verifică dacă fișierul există deja în lista de fișiere încărcate
            const formFiles = this.formFiles.get('files')?.value;
            const fileExists = formFiles.some(
                (uploadedFile: FileUpload) => uploadedFile.original_name === file.name
            );

            if (fileExists) {
                this.toastService.openToast({
                    title: 'Atenție',
                    message: `Fișierul "${file.name}" este deja încărcat.`,
                    type: 'warning',
                });
                continue; // Sari peste acest fișier și continuă cu următorul
            }

            this.uploading = true;

            const formData = new FormData();
            formData.append('file', file, file.name);

            this.dashboardService.fileUpload(formData).subscribe({
                next: (result: any) => {
                    let response =
                        typeof result.status_code !== 'undefined' ? result : result.error;
                    if (typeof response.status_code !== 'undefined') {
                        if (
                            response.status_code == 200 &&
                            typeof response.data !== 'undefined'
                        ) {
                            // Handle the uploaded file by adding it to the 'files' array in the form
                            const files = this.formFiles.get(
                                'files'
                            ) as FormArray;
                            files.push(new FormControl(result.data));

                            this.uploading = false;

                            this.toastService.openToast({
                                title: this.successTitle,
                                message:
                                    helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                                type: this.successIcon,
                            });
                        }
                    } else {
                        // Handle error cases here
                        let errorMessage =
                            environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            errorMessage,
                            this.errorIcon
                        );
                        this.isLoading = false;
                        this.uploading = false;
                    }
                },
                error: (result: any) => {
                    this.isLoading = false;
                    this.uploading = false;
                    this.onHttpError(result.error);
                },
            });
        }

        // Reset the input value to allow re-uploading the same file
        inputElement.value = '';
    }

    downloadFile(uploadedFile: FileUpload) {
        const fullPath = this.dashboardService.tempFileDownloadUrl;
        const payload = {
            fileName: uploadedFile.filename,
            originalName: uploadedFile.original_name,
        }
        this.isLoading = true;
        this.appFilesService.postDownloadFile(fullPath, payload)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('Download doc error: ', err);
                this.isLoading = false;
            })
    }

    removeFile(index: number) {
        const files = this.formFiles.get('files') as FormArray;
        if (index > -1 && index < files.length) {
            files.removeAt(index);
        }
    }

    onHttpError(res: any, showErrorsInToast: boolean = false) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                if (showErrorsInToast) {
                    this.toastService.openToast({
                        title: this.errorTitle,
                        message: msg,
                        type: this.errorType,
                    });
                } else {
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                }
            });
        } else {
            let errorMessage =
                environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(
                this.errorTitle,
                errorMessage,
                this.errorIcon
            );
        }
    }

    findInvalidControls(formGroup: FormGroup) {
        const invalid = [];
        const controls = formGroup.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
        return invalid;
    }

    areFormsValid() {
        this.form.markAllAsTouched();
        this.form.updateValueAndValidity();
        this.formEmitent.markAllAsTouched();
        this.formEmitent.updateValueAndValidity();

        this.tipDocumenteControl.markAsTouched();
        this.entitatiEmitentByCNPControl.markAsTouched();

        if (
            this.sourceArr.length === 0 ||
            this.form.invalid ||
            this.formEmitent.invalid ||
            (this.showFormFiles && this.formFiles.invalid)
        ) {
            console.log('Invalid in this.form:', this.findInvalidControls(this.form));
            console.log('Invalid in this.formEmitent:', this.findInvalidControls(this.formEmitent));
            return false;
        } else {
            return true;
        }
    }


    submitForm(closeModal: boolean = false) {
        if (this.areFormsValid()) {
            Swal.fire({
                title: helper.dialogConfig.commonTitles.areYouSure,
                text: 'O să înregistrați documentul completat în registratură!',
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: helper.dialogConfig.buttonLabels.close,
                confirmButtonColor: helper.dialogConfig.colorButtons.standard,
                confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
                showLoaderOnConfirm: true,
                reverseButtons: true,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.storeDoc(closeModal);
                }
            });
        } else {
            Swal.fire({
                title: helper.dialogConfig.headers.error,
                text: 'Verificați din nou câmpurile obligatorii şi validitatea informațiilor.',
                icon: 'error',
                confirmButtonText: helper.dialogConfig.buttonLabels.close
            });
        };
    }

    storeDoc(closeModal: boolean = false) {
        this.isLoading = true;

        const data_deces_input = this.formEmitent.value.data_deces_input;

        const document = {
            ...this.form.value,
            source: 0, // Hard coded
            sourceArr: this.sourceArr,
            emitent: {
                ...this.formEmitent.value,
                data_deces: data_deces_input ? formatDate(data_deces_input, 'yyyy-MM-dd', 'en-US') : '',
            },
            emitent_secundar: this.formSecundar.value,
            instiintare: this.toStiintaRecords.map((item, index) => {
                item.key = index + 1
                return item;
            }),
            // docData
            id_document: this.docData ? this.docData.id_document : null,
            id_document_activity: this.data.idDocumentActivity,

            // informatii: null, // needed ?
        };

        const payload = {
            document,
            files: this.formFiles.value.files,
        }

        // console.log(payload);
        this.dashboardService
            .storeDocumentIesire(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    Swal.fire({
                        title: `${res.data.reg_number} - ${res.data.reg_date}`,
                        text: `Documentul înregistrat cu succes cu numărul ${res.data.reg_number} - ${res.data.reg_date}`,
                        icon: 'success',
                        showCancelButton: true,
                        cancelButtonColor: helper.dialogConfig.colorButtons.info,
                        cancelButtonText: helper.dialogConfig.buttonLabels.close,
                        confirmButtonColor: helper.dialogConfig.colorButtons.secondary,
                        confirmButtonText: 'Deschide Document',
                        showLoaderOnConfirm: true,
                        // reverseButtons: true,
                        allowOutsideClick: false,
                        preConfirm: () => {
                            // Redirect to document url when Confirmed(Deschide Document) is clicked
                            const url = `#/documente?id=${res.data.id_document}`;
                            window.open(url, '_blank');

                            // Return false to prevent the modal from closing
                            return false;
                        }
                    }).then((result) => {
                        // This will only trigger when Cancel is clicked
                        if (result.isDismissed) {
                            if (closeModal) {
                                this.dialogRef.close({ success: true, resData: res.data });
                            } else {
                                // Clear files when modal is not closed
                                const files = this.formFiles.get('files') as FormArray;
                                files.clear();
                            }
                        }
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
